import { hasFeatureCanary } from '@citrite/workspace-ui-platform';
import { useConfigurationContext } from 'Configuration/useConfigurationContext';
import { FeatureFlag } from 'Environment/FeatureFlag';

export const useFeatureCanary = (featureFlag: FeatureFlag): boolean => {
	const { workspaceConfiguration } = useConfigurationContext();

	return hasFeatureCanary(workspaceConfiguration, featureFlag);
};
